export enum EConditionPrelevement {
    EnActivite = 1,
    HorsActivite = 2,
}